import { Box, Button } from '@chakra-ui/react';
import styled from '@emotion/styled';
import VkBg1Image from '../static/images/vkbg1.svg';
import VkBg2Image from '../static/images/vkbg2.jpg';
import VkBg3Image from '../static/images/vkbg3.svg';

export const VkPage = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1024px;
  margin: auto;
  justify-content: center;
  padding: ${({ theme }) => theme.space[4]};

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    ${({ theme }) => theme.space[9]};
  }
`;

export const ContainerStyled = styled(Box)`
  border-radius: 20px;
  padding: ${({ theme }) => theme.space[8]};
  display: flex;
`;

export const ContainerSolutionStyled = styled(ContainerStyled)`
  background-image: url('${VkBg1Image}');
  background-size: cover;
`;

export const ContainerFirstStyled = styled(ContainerSolutionStyled)`
  flex-direction: column-reverse;
  justify-content: space-between;

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    max-height: 448px;
    flex-direction: row;
  }
`;

export const ContainerGroupStyled = styled(ContainerStyled)`
  flex-direction: column-reverse;
  justify-content: space-between;
  gap: ${({ theme }) => theme.space[4]};
  margin-top: ${({ theme }) => theme.space[4]};

  position: relative;
  overflow: hidden;

  ::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url('${VkBg2Image}') no-repeat center center;
    background-size: cover;
    z-index: -1;
  }

  :nth-of-type(even)::before {
    transform: scaleX(-1);
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    max-height: 329px;
    flex-direction: row-reverse;
  }
`;

export const ContainerLastStyled = styled(ContainerStyled)`
  flex-direction: column-reverse;
  justify-content: space-between;
  gap: ${({ theme }) => theme.space[4]};
  background-image: url('${VkBg3Image}');
  background-size: cover;

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    max-height: 329px;
    flex-direction: row;
    padding: 0;
  }
`;

export const ConnectButton = styled(Button)`
  border-radius: 100px;
  background: #14a3a0;
  color: ${({ theme }) => theme.colors.white};
  padding: 25px 30px;

  &:hover {
    background: #107f8c;
  }
`;
